// extracted by mini-css-extract-plugin
export var button = "feeds-module--button--ffce9";
export var content = "feeds-module--content--80a12";
export var feeds = "feeds-module--feeds--321d8";
export var icon = "feeds-module--icon--c07b3";
export var item = "feeds-module--item--a60b9";
export var items = "feeds-module--items--17e36";
export var time = "feeds-module--time--0047b";
export var title = "feeds-module--title--fb106";